import React from 'react'
import {useEffect, useState} from 'react'
import Button from '../Button'
import envVariables from '../../data/envVariables'
import usePost from '../../hooks/usePost'
import { currencyList } from '../../data/currencyList'
import SelectInput from '../SelectInput'
import format from "date-fns/format"
import TextInput from '../TextInput'
import PortalFinanceStageBasedCtas from './PortalFinanceStageBasedCtas'
import LoadingOverlay from '../LoadingOverlay'
import { isDealPreAvinode } from '../../utilities/settings'


const PortalFinanceDetails = ({deal, legs}) => {
    const {sending, returnMessage, postData} = usePost()

    const [saleCurrency, setSaleCurrency] = useState()
    const [salePrice, setSalePrice] = useState()
    const [costCurrency, setCostCurrency] = useState()
    const [costPrice, setCostPrice] = useState()
    const [operatorChipping, setOperatorChipping] = useState()

    const [didSetDeal, setDidSetDeal] = useState(false)

    const [paramLegs, setParamLegs] = useState(legs)
    
    
    useEffect(() => {
        if(deal && !didSetDeal) {
            setCostCurrency(deal.cost_Currency)
            setCostPrice(deal.flight_Cost_Non_Currency)
            setSaleCurrency(deal.sale_Currency)
            setSalePrice(deal.sale_Price_Non_Currency)
            setOperatorChipping(deal.operator_chipping)            

            setDidSetDeal(true)
        }
    }, [deal])

    const updateDeal = () => {
        let formData = {}

        formData = {
            dealId: deal.id,
            Cost_Currency: costCurrency,
            Flight_Cost_Non_Currency: costPrice,
            Sale_Currency: saleCurrency,
            Sale_Price_Non_Currency: salePrice,
            Operator_chipping: operatorChipping
        }

        postData(formData, '/api/portal/update-deal')
    }


    return (deal && 
        <>
        <div className='deal_details_form'>
            <div>
                <div className='formRow'>
                    <label>Sale currency:</label> 
                    <SelectInput
                        options={currencyList}
                        value={(value) => setSaleCurrency(value)}
                        defaultValue={saleCurrency}
                        label=''
                        classNames={['select-input--full select-input--form']}
                    />
                </div>
                <div className='formRow'>
                    <label>Sale price:</label> 
                    <TextInput
                        label=''
                        type='numeric'
                        defaultValue={salePrice}
                        value={(newValue) => setSalePrice(newValue)}
                    />
                </div>
                <div className='formRow'>
                    <label>Cost currency:</label> 
                    <SelectInput
                        options={currencyList}
                        value={(value) => setCostCurrency(value)}
                        defaultValue={costCurrency}
                        label=''
                        classNames={['select-input--full select-input--form']}
                    />
                </div>
                <div className='formRow'>
                    <label>Cost price:</label> 
                    <TextInput
                        label=''
                        type='numeric'
                        defaultValue={costPrice}
                        value={(newValue) => setCostPrice(newValue)}
                    />
                </div>
                <div className='formRow'>
                    <label>Operator Chipped Value:</label> 
                    <TextInput
                        label=''
                        type='numeric'
                        defaultValue={operatorChipping}
                        value={(newValue) => setOperatorChipping(newValue)}
                    />
                </div>
            </div>
            <div>
                <Button 
                    classNames={['button--tertiary']}
                    onClick={() => updateDeal()}
                    disabled={sending}
                >Save changes</Button>
            </div>
        </div>

        {paramLegs && !isDealPreAvinode(deal) &&
            <>
            <div className='deal_details_form'>
                <div>
                    {paramLegs && !isDealPreAvinode(deal) && paramLegs.sort((a, b) => {return a.leg_Number < b.leg_Number ? -1 : 1}).map((leg, index) => {
                        return (
                            <>
                            <div className='formRow'>
                                <strong><em>Leg {index+1}</em></strong>
                            </div>
                            <div className='formRow'>
                                <label>From:</label> {leg.airport_From}
                            </div>
                            <div className='formRow'>
                                <label>To:</label> {leg.airport_To}
                            </div>
                            <div className='formRow'>
                                <label>Date:</label> {format(new Date(leg.leg_Date_and_Time), 'dd/MM/yyyy HH:mm')}
                            </div>
                            {(deal.leg_1_Date_of_Arrival && index === 0) && 
                                <div className='formRow'>
                                    <label>Arrival date/time:</label> {format(new Date(deal.leg_1_Date_of_Arrival), `dd/MM/yyyy`)} {deal.leg_1_Time_of_Arrival}
                                </div>
                            }
                            {(deal.leg_2_Date_of_Arrival && index === 1) && 
                                <div className='formRow'>
                                    <label>Arrival date/time:</label> {format(new Date(deal.leg_2_Date_of_Arrival), `dd/MM/yyyy`)} {deal.leg_2_Time_of_Arrival}
                                </div>
                            }
                            <div className='formRow'>
                                <label>Pax:</label> {leg.number_of_Passengers}
                            </div>
                            <div className='formRow'>
                                <label>Bags:</label> {leg.number_of_Bags}
                            </div>
                            </>
                        )
                    })} 
                </div>
            </div>
            </>
        }

        {(deal) && 
            <PortalFinanceStageBasedCtas
                deal={deal} 
            />
        }
        {sending && 
            <LoadingOverlay />
        }
        </>
    )
}

export default PortalFinanceDetails